import { render, staticRenderFns } from "./CirculoUsuario.vue?vue&type=template&id=25ac0344&scoped=true"
import script from "./CirculoUsuario.vue?vue&type=script&lang=js"
export * from "./CirculoUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ac0344",
  null
  
)

export default component.exports